import { Injectable } from '@angular/core';
import { FormDataService } from '@services/form-data/form-data.service';
import { emptyMerchantOption } from '@utility/constants';
import { MdsOptionGeneric } from '@utility/utility';
import { BehaviorSubject, Observable, filter, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RequestMerchantStateService {
    constructor(private formService: FormDataService) {}

    private readonly paymentRequestMerchants = new BehaviorSubject<MdsOptionGeneric<number>[] | null>(null);

    public getPaymentRequestMerchants(): Observable<MdsOptionGeneric<number>[]> {
        if (this.paymentRequestMerchants.getValue() === null)
            this.formService
                .getPaymentRequestMerchants()
                .pipe(tap((value) => this.paymentRequestMerchants.next([emptyMerchantOption, ...value])))
                .subscribe();

        return this.paymentRequestMerchants.pipe(filter(Boolean));
    }

    private readonly travelRequestMerchants = new BehaviorSubject<MdsOptionGeneric<number>[] | null>(null);

    public getTravelRequestMerchants(): Observable<MdsOptionGeneric<number>[]> {
        if (this.travelRequestMerchants.getValue() === null)
            this.formService
                .getTravelRequestMerchants()
                .pipe(tap((value) => this.travelRequestMerchants.next([emptyMerchantOption, ...value])))
                .subscribe();

        return this.travelRequestMerchants.pipe(filter(Boolean));
    }
}
